import { createSelector } from 'reselect';
import type { FieldKey } from '@atlassian/jira-polaris-domain-field/src/field/types.tsx';
import { createGetFieldMapping } from './fields.tsx';

export const createGetOptionLabel = (fieldKey: FieldKey, id: string) => {
	const getFieldMapping = createGetFieldMapping(fieldKey);
	return createSelector(getFieldMapping, (fieldMapping) => fieldMapping?.getLabel(id));
};
